import { LanguageConst } from '../../../utils/resources/languageconst';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface WarnAlertCSSStyle extends UIComponentCSSStyle{
    getInnerWrapperCSSStyle():object;
    getCloseButtonDivCSSStyle():object;
    getAlertImageDivCSSStyle():object;
    getAlertMessageDivCSSStyle():object;
    getMobileAlertImageDivCSSStyle():object;
    getMobileAlertMessageDivCSSStyle():object;
    getButtonDivCSSStyle():object;
    getAuthenticateButtonDivCSSStyle():object;
    getMobileWrapperCSSStyle():object;
    getMobileCloseButtonDivCSSStyle():object;

}
export class WarnAlertCSSStyleImpl extends UIComponentCSSStyleImpl implements WarnAlertCSSStyle
{
    
    getWrapperCSSStyle():object
    {
        return{
            width:'440px',
            display:'flex', 
            height:'617px',
            borderRadius:'8px', 
            backgroundColor:'#FF8F18'
        };
    }

    getMobileWrapperCSSStyle():object
    {
        return{
            width:'auto',
            display:'flex', 
            height:'440px',
            borderRadius:'8px', 
            backgroundColor:'#FF8F18'
        };
    }


    getInnerWrapperCSSStyle():object
    {
        return{
            width:'100%', height:'100%'
        };
    }
    getCloseButtonDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'17px', 
            height:'20px',
            paddingRight:'20px',
            // marginLeft:'403px',
            cursor:'pointer',
            textAlign:"right"

        };
    }

    getMobileCloseButtonDivCSSStyle():object
    {
        return{
            // width:'20px',
            // marginTop:'17px', 
            // height:'20px',
            // marginRight:'10px',
            // marginLeft:'260px',
            // cursor:'pointer'
            width:'100%',
            marginTop:'17px', 
            height:'20px',
            paddingRight:'20px',
            // marginLeft:'403px',
            cursor:'pointer',
            textAlign:"right"
        };
    }

    getMobileAlertImageDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'30px', 
            height:'70px',
            // marginLeft:'120px',
            marginBottom:'30px',
            textAlign:'center'
        };
    }

    getMobileAlertMessageDivCSSStyle():object
    {
        return{
            width:'auto',
            margin:'0px 43px 50px 43px',
            textAlign:'center', 
            height:'150px',
            fontFamily:this.getResources().getFontFamily(), 
            fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '18px' : '14px',
            fontWeight:900,
            color:'#FFFFFF',
            lineHeight:'30px',
            letterSpacing:'0'
        };
    }

    getAlertImageDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'102px', 
            height:'150px',
            // marginLeft:'144.5px',
            marginBottom:'50px',
            textAlign:'center'
        };
    }

    getAlertMessageDivCSSStyle():object
    {
        return{
            width:'auto',
            margin:'0px 86px 132px 86px',
            textAlign:'center', 
            height:'80px',
            fontFamily:this.getResources().getFontFamily(), 
            fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '25px' : '22px',
            fontWeight:900,
            color:'#FFFFFF',
            lineHeight:'30px',
            letterSpacing:'0'
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
            margin:'0px 120px 40px 120px',
            color: "#FF8F18", 

        };
    }
    getAuthenticateButtonDivCSSStyle():object{
        return{
            margin:'40px 25px 40px 25px',
            color:'#429984',
             display:'flex',
             height:'auto',
            flexDirection:'row',
            justifyContent:'center',
            alignItems:'center'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/warnalertcss.tsx